import Evento from "../components/eventos/Evento";
import EventoPlaceholder from "../components/load/EventoPlaceholder";

const Festivales = ({ data, loading }) => {
  return (
    <main className="m-0 p-0">
      {/* Secci�n de portada con im�genes responsive */}
      <section className="w-100" style={{ paddingTop: "80px" }}>
        <div className="container-fluid px-0">
          {/* Imagen para desktop */}
          <img
            src="/assets/img/galeria/horizontal_institucional.jpg"
            alt="Festival Banner"
            className="w-100 d-none d-md-block"
            style={{ objectFit: "cover", maxHeight: "500px" }}
          />
          {/* Imagen para mobile */}
          <img
            src="/assets/img/galeria/WhatsApp Image 2026-09-16 at 8.46.15 PM.jpeg"
            alt="Festival Banner Mobile"
            className="w-100 d-block d-md-none"
            style={{ objectFit: "cover", maxHeight: "400px" }}
          />
        </div>
      </section>

      {/* Secci�n de informaci�n del festival */}
      {data && (
        <section className="py-4 bg-light">
          <div className="container-md">
            <div className="row">
              <div className="col-12">
                <h1 className="Grifter text-center text-dark mb-3">
                  {data.nombre || ""}
                </h1>
                {data.descripcion && (
                  <p className="text-center text-muted mb-4">
                    {data.descripcion}
                  </p>
                )}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Secci�n de eventos del festival */}
      <section
        id="eventos-festival"
        style={{ paddingTop: "30px", paddingBottom: "50px" }}
      >
        <div className="container-md">
          <div className="row">
            <div className="col-12 mb-4">
              <h2 className="Grifter text-dark">Eventos del Festival</h2>
              <hr />
            </div>

            {/* Lista de eventos */}
            {!loading && data?.eventos
              ? data.eventos.map((evento, index) => (
                  <div
                    className="col-6 col-md-6 col-lg-4 mb-3"
                    style={{ padding: "3px" }}
                    key={index}
                  >
                    <Evento
                      data={evento}
                      descount={
                        evento.cupones?.length > 0 &&
                        evento?.cupones[0]?.visible == 1
                      }
                    />
                  </div>
                ))
              : null}

            {/* Placeholders durante la carga */}
            {loading &&
              [1, 2, 3, 4, 5, 6, 7, 8, 9].map((item) => (
                <div className="col-6 col-md-6 col-lg-4 mb-3" key={item}>
                  <EventoPlaceholder />
                </div>
              ))}

            {/* Mensaje cuando no hay eventos */}
            {!loading && (!data?.eventos || data.eventos.length === 0) && (
              <div className="col-12 text-center py-5">
                <p className="text-muted">
                  No hay eventos disponibles en este festival.
                </p>
              </div>
            )}
          </div>
        </div>
      </section>
    </main>
  );
};

export default Festivales;
